/* Responsive video in post content */
;(function () {
  const sources = [
    '.gh-content iframe[src*="youtube.com"]',
    '.gh-content iframe[src*="youtube-nocookie.com"]',
    '.gh-content iframe[src*="player.vimeo.com"]',
    '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
    '.gh-content object',
    '.gh-content embed',
  ]
  reframe(document.querySelectorAll(sources.join(',')))
})()

/* Infinite scroll pagination */
;(function () {
  if (
    !document.body.classList.contains('home-template') &&
    !document.body.classList.contains('post-template')
  ) {
    pagination()
  }
})()
;(function () {
  const pageNavigation = document.getElementById('page-navigation')
  if (!pageNavigation) return

  function handleScroll() {
    if (window.scrollY > 100) {
      pageNavigation.classList.add('page-navigation-on-scroll')
    } else {
      pageNavigation.classList.remove('page-navigation-on-scroll')
    }
  }

  window.addEventListener('scroll', handleScroll)
  handleScroll()
})()
;(function () {
  const menu = document.querySelector('.page-navigation-menu-sm')
  const menuLogo = document.querySelector('.page-navigation-logo')
  const menuInner = document.querySelector('.page-navigation-menu-sm-inner')
  const menuToggle = document.querySelector('.page-navigation-menu-sm-toggle')
  const menuToggleLines = document.querySelector('.page-navigation-menu-sm-toggle-lines')
  if (!menuToggle || !menu || !menuInner || !menuToggleLines || !menuLogo) return

  menuToggle.addEventListener('click', function () {
    menu.classList.toggle('is-open')
    menuInner.classList.toggle('is-open')
    menuToggleLines.classList.toggle('is-open')
    menuLogo.classList.toggle('is-open')
  })
})()
